(ns common.graph
  "Namespace providing functions to operate on a directed graph represented as
  an adjacency list.")

(defn- search
  [graph visited frontier]
  (lazy-seq
   (when-let [vertex (peek frontier)]
     (let [neighbours (graph vertex)
           frontier (into (pop frontier) (remove visited neighbours))
           visited (into visited neighbours)]
       (cons vertex (search graph visited frontier))))))

(defn depth-first-search
  "Return vertices connected to `start`, in depth first order."
  [graph start]
  (search graph #{start} [start]))

(defn breadth-first-search
  "Return vertices connected to `start`, in breadth first order."
  [graph start]
  (search graph #{start} #queue [start]))

(defn invert
  "Invert direction of edges in `graph`"
  [graph]
  (->> graph
       (mapcat (fn [[dependant dependencies]]
                 [{dependant '()}
                  (zipmap dependencies (repeat (list dependant)))]))
       (apply merge-with concat)))

(defn merge-map
  "Merge map `m2` in map `m1`, using `graph` to describe the relation
  between the 2 maps. The `graph` keys represent the `target` path in `m1` as
  a coll of keys, the values represent the `source` path(s) in `m2` as a
  coll of keys.

  A merge strategy can be provided, which will receive the current value in `m1`
  and the value we intent to merge from `m2`. The return value of this strategy
  is the value we assoc in `m1`."
  ([graph m1 m2]
   (merge-map (fn [_a b] b) graph m1 m2))
  ([strategy graph m1 m2]
   (letfn [(unpack-edges [[to froms]]
             (map vector (repeat to) froms))
           (merge* [acc [to-ks from-ks]]
             (update-in acc to-ks strategy (get-in m2 from-ks)))]
     (->> graph
          (mapcat unpack-edges)
          (reduce merge* m1)))))
